import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import toyota from "./../../../../assets/info/landcruiser-hero.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";

const ToyotaLandcruiser = () => {
  useSmallNav("Toyota Landcruiser");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Toyota Landcruiser"} bolder />
        <InfoHero image={toyota} />
        <InfoGrid>
          <div>
            <p>
              Toyota Landcruiser istnieje na rynku prawie tak długo jak Pedders.
              Jesteśmy wielkim fanem tego auta, możliwości terenowych i
              niezawodności jednego z najlepszych samochodów 4x4.
            </p>
            <p>
              Pedders od wielu lat specjalizuje się w produkcji i testowaniu
              wyposażenia podwozia pojazdów terenowych i z dumą możemy
              powiedzieć, że możemy zaoferować najlepsze rozwiązania dla Twojego
              Landcruisera.
            </p>
            <p>
              Zawieszenie 4WD Trak Ryder jest efektem wielu lat rozwoju
              technicznego i zapewnia nowy poziom prowadzenia i komfortu,
              właścicielom Landcruiserów. Zawieszenia Pedders TrakRyder to setki
              wysokiej jakości komponentów, z których każdy ma na celu poprawę
              prowadzenia poszczególnych pojazdów.
            </p>
            <p>
              Istnieje wiele różnych wersji Landcruisera, począwszy od serii 40
              do 200, Prado, w wersjach z krótkim, średnim i długim rozstawie
              osi. Każdy Landcruiser ma indywidualnie zaprojektowane
              zawieszenia, a my oferujemy wiele części do jego modernizacji - do
              podniesienia, wzmocnienia lub po prostu odświeżenia Landcruisera.
            </p>
            <InfoHeader
              size="smaller"
              text={
                "Pierwsze pytanie brzmi: „Czego oczekuję od mojego Landcruisera?”"
              }
            />
            <p>
              Jeśli chcesz bawić się swoim samochodem, podnieść zawieszenie,
              zwiększyć skok zawieszenia, założyć większe opony itp., sprawdź
              kategorię „Zestawy”.
            </p>
            <p>
              Jeśli stale holujesz lub przewozisz ładunki swoim Landcruiserem,
              możesz oczekiwać lepszych parametrów zarówno przy standardowej
              wysokości jak i przy podniesionym samochodzie, przy jednoczesnym
              zachowaniu prawidłowych parametrów pracy zawieszenia.
            </p>
            <p>
              Jeśli jesteś zapalonym kierowcą, być może chcesz zachować
              standardową wysokość, ale usztywnić pojazd, aby uzyskać większe
              wyczucie pojazdu, lepsze właściwości jezdne i kontrolę nad nim.
              Oferujemy wszystkie warianty.
            </p>
            <p>
              Wybierz swój pojazd z listy, a jeśli masz jakieś wątpliwości, nie
              wahaj się zapytać, a nasz zespół pomoże w doborze.
            </p>
            <InfoHeader
              size="smaller"
              text={"Jak wysoki będzie mój Landcruiser?"}
            />
            <p>
              Chociaż opisy zestawów podają przybliżone parametry, mogą one być
              trochę mylące. Jak wspomniano, sprężyny osiadają z czasem, więc
              1,5-calowe podwyższenie może okazać się nieco większe w
              rzeczywistości. Aby upewnić się, że dokładnie wiesz, co
              otrzymujesz, podajemy również dopasowaną wysokość. Mierzy się ją
              od dolnego rantu felgi do nadkola. Zaletą tej metody jest to, że
              wybór opon nie ma wpływu na podaną wysokość.
            </p>
            <p>
              Jeśli nadal nie jesteś pewien, czy mamy odpowiednie dla Ciebie
              części? Nie wiesz, który zestaw jest dla Ciebie odpowiedni?
              Skontaktuj się z nami, a nasz zespół zadba o to, że otrzymasz
              części odpowiednie do Twoich potrzeb.
            </p>
            <iframe
              title="Toyota Landcruiser"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/uKjltW4e6X8"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Toyota")
              .models.find((e) => e.display === "Landcruiser")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              title="Toyota Landcruiser"
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title="Toyota Landcruiser"
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Toyota" model="Landcruiser" /> */}
      </Container>
    </section>
  );
};

export default ToyotaLandcruiser;
